import styled from "styled-components";
import colors from "../../../config/colors";

const InlineButtons = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 26px;
  margin: 30px 0;
  background: ${colors.GRAY_EXTRA_LIGHT};
  @media (max-width: 600px) {
    flex-direction: column;
    button, a {
      width: 100%;
      margin: 10px;
    }
  }
`;

export default InlineButtons;
